import type { LayoutDataType } from '../../types';

export const POOLSIDE_OPTIONS: {
  id: NonNullable<LayoutDataType['poolside']>;
  title: string;
}[] = [
  {
    id: 'watch',
    title: 'Watch from a distance',
  },
  {
    id: 'help',
    title: 'Offer to help',
  },
  {
    id: 'small_talk',
    title: 'Sit poolside and make small talk',
  },
];
